// Accounting period presets. Dates are local YYYY-MM-DD strings to match the API.
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function todayISO() {
  return iso(new Date());
}

export function addDays(isoDate, days) {
  const d = new Date(`${isoDate}T00:00:00`);
  d.setDate(d.getDate() + days);
  return iso(d);
}

function fyStart(ref, fyMonth) {
  const y = ref.getMonth() + 1 >= fyMonth ? ref.getFullYear() : ref.getFullYear() - 1;
  return new Date(y, fyMonth - 1, 1);
}

export function periodPresets(fyMonth = 4) {
  const now = new Date();
  const mStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const lmStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lmEnd = new Date(now.getFullYear(), now.getMonth(), 0);
  const q = Math.floor(((now.getMonth() + 1 - fyMonth + 12) % 12) / 3);
  const fy = fyStart(now, fyMonth);
  const qStart = new Date(fy.getFullYear(), fy.getMonth() + q * 3, 1);
  const lfy = new Date(fy.getFullYear() - 1, fy.getMonth(), 1);
  const lfyEnd = new Date(fy.getFullYear(), fy.getMonth(), 0);
  const fyLabel = (d) => `FY ${d.getFullYear()}–${String(d.getFullYear() + 1).slice(2)}`;
  return [
    { id: "today", label: "Today", start: iso(now), end: iso(now) },
    { id: "month", label: "This month", start: iso(mStart), end: iso(now) },
    { id: "last-month", label: "Last month", start: iso(lmStart), end: iso(lmEnd) },
    { id: "quarter", label: "This quarter", start: iso(qStart), end: iso(now) },
    { id: "fy", label: fyLabel(fy), start: iso(fy), end: iso(now) },
    { id: "last-fy", label: fyLabel(lfy), start: iso(lfy), end: iso(lfyEnd) },
  ];
}
